import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Grid, Typography } from '@material-ui/core';
import './styles.css';
import DraftTable from '../../invoices/common/draftTable';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import TabList from '../../../components/checklistTab/tabList';
import { CommonConfig } from '../../../config/common-config';

const useStyles = makeStyles((theme) => ({
    btnbottom: {
        borderBottom: '#feef6',
    },

    root: {
        boxShadow: '0px 5px 10px #efefef !important',
        borderRadius: '8px',
        minHeight: '300px',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        color: '#727272',
        fontSize: '20px',
        fontFamily: 'Rubik',
        fontWeight: '500',
        marginBottom: '20px',
    },
    pos: {
        marginBottom: 12,
    },
    rootCard: {
        marginBottom: '20px',
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        '& > *': {
            margin: theme.spacing(1),
        },
    },

    bottomLine: {
        padding: '0',
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    inlineDisplayFont: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 20px',
            color: '#7779ba',
            marginTop: '-10px',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        margin: '0px !important',
    },
    inlinebutton: {
        padding: '0',
        margin: '0',
        '& li': {
            listStyle: 'none',
            display: 'inline-block',
            marginRight: '15px',
            width: '100%',
        },
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    fileNameMargin: {
        marginTop: '6px',
        marginBottom: '0px'
    },
    flexRow: {
        flexDirection: 'row !important'
    },
    removeButton: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        marginRight: '15px !important'
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
}));

export default function IMCDraftListClient(props) {
    const classes = useStyles();
    const dispatch = useDispatch({});
    const history = useHistory();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantName = tennantDetails && tennantDetails.tennantName;
    const stageID = useSelector((state) => state.serviceCheckListReducer.selectedStageId);

    useEffect(() => {
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/draft-statements/by-serviceId/${tennantName}/${serviceIdValue}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response && response.data) {
                    formatDate(response.data)
                    setRows(response.data)
                }
            })
            .catch((error) => {
                const errResult = error.response;
                if (errResult && errResult.data) {
                }
            });
    }, [bearerToken])

    function formatDate(props) {
        return props.map((element) => {
            const tempStartDate = element.date;
            const pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
            const formatDate = new Date(tempStartDate.replace(pattern, '$3-$2-$1'));
            element.date = moment(formatDate).format('DD-MM-YYYY');
        });
    }

    const headcells = [
        { id: 'versionNumber', label: 'Version' },
        { id: 'date', label: 'Date' },
        { id: 'finalVersionByClient', label: 'Final Version Chosen by client' },
        { id: 'finalVersionByIMC', label: `Final Version Chosen by ${tennantName}` },

    ];

    const addVersion = () => {
        history.push({
            pathname: '/menu/imc-add-draft-client',
        });
    }

    return (
        <div>
            <TabList />
            <Card className="custom-table">
                <CardContent className="card-title-display">
                    <Grid item xs={12} sm={8}>
                        <Typography className="card-title">Draft Statements</Typography>
                    </Grid>
                    {/* <Grid item xs={12} sm={6} className="card-search">
                        <div className="card-add-button">
                            <Button variant="outlined" color="primary" size="small" onClick={addVersion} className={classes.button}>
                                Add Version
                            </Button>
                        </div>
                    </Grid> */}
                </CardContent>
                <CardContent className="card-table-display">
                    {rows && rows.length ? (
                        <>
                            <DraftTable
                                // handleCount={handleCount}
                                stageID={stageID}
                                headcells={headcells}
                                rows={rows}
                                action
                                // pageDetails={pageDetails}
                                // prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                                loading={loading}
                            />
                        </>
                    ) : (
                            <div className={classes.noRecord}>
                                <h1>No records to display</h1>
                            </div>
                        )}
                </CardContent>
            </Card>
        </div>
    );
}
